import React from 'react';
import { Table, Tag, Space } from 'antd';

import LevelChart from './levelChart';
import WidgetAjax from '../../../widget/WidgetAjax'

class Credit extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chartValue: '极低'
        }

    }

    componentDidMount() {
        this.setState({ loading: false });
    }

    render() {
        const { chartValue } = this.state;

        const { title, id } = this.props;

        const normDataSource = [
            {
                key: '1',
                name: '总资产周转率相对水平	',
                age: '较低',
            },
            {
                key: '2',
                name: '净资产周转率相对水平	',
                age: '较低',
            },
        ];

        const normColumns = [
            {
                title: '指标名称',
                dataIndex: 'name',
                key: 'name',
                align: "left",
                width: '50%',
                className: 'tableTitle'
            },
            {
                title: '指标值',
                dataIndex: 'age',
                key: 'age',
                align: "left",
                width: '50%',
                className: 'tableTitle'
            },
        ];

        const averageDataOne = [
            {
                key: '1',
                nianfen:'2013',
                entNum:'13',
                zongzichan:'123214124',
                yingyeshouru:'123513251',
                jinglirun:'-15%',
                zichanfuzhai:'22%',
            },
        ];

        const averageColumns = [
            {
                title: '年份\指标',
                dataIndex: 'nianfen',
                key: 'nianfen',
                align: "left",
                width: '16.6%',
                className: 'tableTitle'
            },
            {
                title: '企业个数（个）',
                dataIndex: 'entNum',
                width: '16.6%',
                align: "left",
                key: 'entNum',
                className: 'tableTitle'
            },
            {
                title: '总资产（万元）',
                dataIndex: 'zongzichan',
                width: '16.6%',
                align: "left",
                key: 'zongzichan',
                className: 'tableTitle'
            },
            {
                title: '营业收入（万元）',
                dataIndex: 'yingyeshouru',
                width: '16.6%',
                align: "left",
                key: 'yingyeshouru',
                className: 'tableTitle'
            },
            {
                title: '净利润率',
                dataIndex: 'jinglirun',
                width: '16.6%',
                align: "left",
                key: 'jinglirun',
                className: 'tableTitle'
            },
            {
                title: '资产负债率',
                dataIndex: 'zichanfuzhai',
                width: '16.6%',
                align: "left",
                key: 'zichanfuzhai',
                className: 'tableTitle'
            },
        ];

        const levelBriefData = [
            {
                key: '1',
                fuhao: 'R1',
                gailv: '0.68%',
                miaoshu: '最好的信用评级等级，具有最好的信用质量。',
            },
            {
                key: '2',
                fuhao: 'R2',
                gailv: '0.78%',
                miaoshu: '次优的等级，具有几乎最好的信用质量。',
            },
            {
                key: '3',
                fuhao: 'R3',
                gailv: '0.86%',
                miaoshu: '有非常强的能力满足债务的偿付。',
            },
            {
                key: '4',
                fuhao: 'R4',
                gailv: '0.93%',
                miaoshu: '有强的能力满足债务的偿付。',
            },
            {
                key: '5',
                fuhao: 'R5',
                gailv: '0.78%',
                miaoshu: '有较好的能力满足债务的偿付，较小的外部环境的变化较难对其产生影响。',
            },
            {
                key: '6',
                fuhao: 'R6',
                gailv: '1.09%',
                miaoshu: '满足债务的偿付能力一般，较小的外部环境的变化容易对其产生影响。',
            },
            {
                key: '7',
                fuhao: 'R7',
                gailv: '1.48%',
                miaoshu: '满足债务的偿付能力一般，外部环境的变化容易削弱其偿付能力。',
            },
            {
                key: '8',
                fuhao: 'R8',
                gailv: '2.26%',
                miaoshu: '勉强有能力满足债务的偿付，但面临着外部环境变化引起的风险。',
            },
            {
                key: '9',
                fuhao: 'R9',
                gailv: '3.09%',
                miaoshu: '勉强有能力满足债务的偿付，但不利的商业、金融或经济环境可能会一定程度削弱债务人的能力或意愿。',
            },
            {
                key: '10',
                fuhao: 'R10',
                gailv: '5.36%',
                miaoshu: '勉强有能力满足债务的偿付，但不利的商业、金融或经济环境可能会削弱债务人的能力或意愿。',
            },
            {
                key: '11',
                fuhao: 'R11',
                gailv: '10.46%',
                miaoshu: '勉强有能力满足债务的偿付，但不利的商业、金融或经济环境可能会很快地削弱债务人的能力或意愿。',
            },
            {
                key: '12',
                fuhao: 'R12',
                gailv: '16.61%',
                miaoshu: '信用质量已经非常的差，容易难以偿付相应的债务，依赖于一个稳定的商业、金融或经济环境。',
            },
            {
                key: '13',
                fuhao: 'R13',
                gailv: '22.22%',
                miaoshu: '信用质量已经非常的差，很容易难以偿付相应的债务，依赖于一个稳定的商业、金融或经济环境。',
            },
            {
                key: '14',
                fuhao: 'R14',
                gailv: '32.55%',
                miaoshu: '信用质量已经非常的差，非常容易难以偿付相应的债务，高度依赖于一个好的商业、金融或经济环境。',
            },
            {
                key: '15',
                fuhao: 'R15',
                gailv: '100%',
                miaoshu: '违约。',
            },
        ]

        const levelBriefColumns = [
            {
                title: '等级符号',
                dataIndex: 'fuhao',
                key: 'fuhao',
                align: "left",
                width: '15%',
                className: 'tableTitle'
            },
            {
                title: '等级概率',
                dataIndex: 'gailv',
                key: 'gailv',
                align: "left",
                width: '15%',
                className: 'tableTitle'
            },
            {
                title: '等级描述',
                dataIndex: 'miaoshu',
                key: 'miaoshu',
                align: "left",
                width: '70%',
                className: 'tableTitle'
            },
        ]



        return (
            <div className='common-box'>
                <div >
                    <div className='common-top' id={"CREDIT_id"} >
                        <div className="img">
                            <img src={require("../../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                        </div>
                        <div className='common-survival' >{title}</div>
                    </div>
                    <div className='common-modular-all' style={{ paddingLeft: '21px' }}>
                        <div className='common-modular-all-modularTitle'>信用质量评分</div>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '60%' }}>
                                <div className='common-modular-all-brief'>
                                    <p>该公司外部环境比较稳定，行业和区域风险处于较低的水平；</p>
                                    <p>该公司企业特质一般，具有一定程度的信用风险；</p>
                                    <p>该公司稳定情况非常好，表现出极低的信用风险；</p>
                                    <p>该公司具有较强的经营水平，表现出较低的信用风险；</p>
                                    <p>该公司负面信息较多，表现出中等程度的信用风险；</p>
                                    <p>该公司利益关联方具有较差的信用表现，表现出较高的信用风险。</p>
                                </div>
                            </div>
                            <div style={{ width: '40%' }} className='common-modular-all-point-chart'>
                                <LevelChart title="信用质量等级" id="Credit" value={chartValue}></LevelChart>
                            </div>
                        </div>
                        <div className='common-modular-all-modularTitle'>信用评级指标详解</div>
                        <div className='table-content'>
                            <table style={{ tableLayout: 'auto' }} >
                                <thead>
                                    <tr>
                                        <td width="25%;" className="detailtitle" style={{ background: '#fafafa' }}>指标名称</td>
                                        <td width="25%;" className="detailtitle" style={{ background: '#fafafa' }}>指标得分</td>
                                        <td width="25%;" className="detailtitle" style={{ background: '#fafafa' }}>子指标名称</td>
                                        <td width="25%;" className="detailtitle" style={{ background: '#fafafa' }}>子指标得分</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td rowspan="3" width="25%">外部环境</td>
                                        <td width="25%" rowspan="3">data.data.two_fen.Invrioment</td>
                                        <td width="25%">细分市场利润水平</td>
                                        <td width="25%">data.data.three_pingfen.Industry</td>
                                    </tr>
                                    <tr>
                                        <td width="25%">细分市场新进入者挑战</td>
                                        <td width="25%">data.data.three_pingfen.Location</td>
                                    </tr>
                                    <tr>
                                        <td width="25%">细分市场行政司法风险</td>
                                        <td width="25%">data.data.three_pingfen.Cycle</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" width="25%">企业特质</td>
                                        <td width="25%" rowspan="2">data.data.two_fen.EntBasic</td>
                                        <td width="25%">经营周期</td>
                                        <td width="25%">data.data.three_pingfen.Scale</td>
                                    </tr>
                                    <tr>
                                        <td width="25%">股东结构</td>
                                        <td width="25%">data.data.three_pingfen.Type</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" width="25%">稳定性</td>
                                        <td rowspan="2" width="25%">data.data.two_fen.BackGroud</td>
                                        <td width="25%">股权稳定性</td>
                                        <td width="25%">data.data.three_pingfen.StocksTructure</td>
                                    </tr>
                                    <tr>
                                        <td width="25%">管理稳定性</td>
                                        <td width="25%">data.data.three_pingfen.Legel</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="3" width="25%">经营水平</td>
                                        <td rowspan="3" width="25%">data.data.two_fen.Manage</td>
                                        <td width="25%">盈利状况</td>
                                        <td width="25%">data.data.three_pingfen.EquityStability</td>
                                    </tr>
                                    <tr>
                                        <td width="25%">运营状况</td>
                                        <td width="25%">data.data.three_pingfen.ManagemenTrisk</td>
                                    </tr>
                                    <tr>
                                        <td width="25%">增长状况</td>
                                        <td width="25%">data.data.three_pingfen.FinancialRisk</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" width="25%">负面风险</td>
                                        <td rowspan="2" width="25%">data.data.two_fen.LessCredit</td>
                                        <td width="25%">行政处罚</td>
                                        <td width="25%">data.data.three_pingfen.Penalty</td>
                                    </tr>
                                    <tr>
                                        <td width="25%">涉诉风险</td>
                                        <td width="25%">data.data.three_pingfen.Related_Lesscredit</td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2" width="25%">关联风险</td>
                                        <td rowspan="2" width="25%">data.data.two_fen.RelateDrisk</td>
                                        <td width="25%">供应链关联风险</td>
                                        <td width="25%">data.data.three_pingfen.Related_Mangement</td>
                                    </tr>
                                    <tr>
                                        <td width="25%">投资关联风险</td>
                                        <td width="25%">data.data.three_pingfen.Investment_related</td>
                                    </tr>
                                    <tr>
                                        <td width="50%" colspan="2">总分评级</td>
                                        <td width="50%" colspan="2"><span style={{ color: 'rgb(246, 176, 53)' }}>(data.data.qualratingnm)</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className='common-modular-all-modularTitle'>信用评级标尺说明</div>
                        <Table size="small" dataSource={levelBriefData} columns={levelBriefColumns} pagination={false} />
                        <div className='common-modular-all-modularTitle'>信用综合评价分布对比</div>
                        <div className='table-content'>
                            <table >
                                <tbody>
                                    <tr>
                                        <td width="35%">行业的中位值</td>
                                        <td colspan="3" width="65%"> data.data.el_creditdycross.ind_avg_score </td>
                                    </tr>
                                    <tr>
                                        <td width="25%">区域排名</td>
                                        <td width="25%"> data.data.el_creditdycross.reg_num </td>
                                        <td width="25%">同区域总企业数</td>
                                        <td width="25%"> data.data.el_creditdycross.reg_max </td>
                                    </tr>
                                    <tr>
                                        <td width="25%">行业排名</td>
                                        <td width="25%"> data.data.el_creditdycross.ind_num </td>
                                        <td width="25%">同行业总企业数</td>
                                        <td width="25%"> data.data.el_creditdycross.ind_max </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className='common-modular-all-modularTitle'>区域行业平均值（北京市-固定电信服务）</div>
                        <Table size="small" dataSource={averageDataOne} columns={averageColumns} pagination={false} />

                        <div className='common-modular-all-modularTitle'>区域行业平均值（北京市-固定电信服务）</div>
                        <Table size="small" dataSource={averageDataOne} columns={averageColumns} pagination={false} />

                    </div>
                </div>
            </div>
        )
    }
}

export default Credit